export const ReportTypes = {
  base: "base",
  creativeAnalysis: "creative_analysis",
};

export const ReportTypesMapping = {
  [ReportTypes.base]: "Performance",
  [ReportTypes.creativeAnalysis]: "Creative",
};
